import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Cookies from 'universal-cookie'

import styles from './Special.module.css'

Special.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func
}

export default function Special ({ active, onClose }) {
  const cookies = new Cookies()

  const options = { path: '/' }

  const changeClass = (type, className) => {
    if (document) {
      document.documentElement.classList.remove(`${type}_2`, `${type}_3`)
      document.documentElement.classList.add(`${type}_${className}`)
    }
  }

  const [font, setFont] = useState(cookies.get('specialSettingsFont', options) || '1')
  const [spacing, setSpacing] = useState(cookies.get('specialSettingsSpacing', options) || '1')
  const [schema, setSchema] = useState(cookies.get('specialSettingsSchema', options) || '1')

  const [fontFamily, setFontFamily] = useState(cookies.get('specialSettingsFontFamily', options) || 'sans-serif');
  const [imagesEnabled, setImagesEnabled] = useState(cookies.get('specialSettingsImagesEnabled', options) !== 'false');

  const resetSettings = () => {
    // Очищаем куки
    cookies.remove('specialSettingsFont', options);
    cookies.remove('specialSettingsSpacing', options);
    cookies.remove('specialSettingsSchema', options);
    cookies.remove('specialSettingsFontFamily', options);
    cookies.remove('specialSettingsImagesEnabled', options);
  
    // Сбрасываем состояния на дефолтные
    setFont('1');
    setSpacing('1');
    setSchema('1');
    setFontFamily('sans-serif');
    setImagesEnabled(true);
  
    // Удаляем классы и CSS-переменные
    document.documentElement.classList.remove(
      'font_2', 'font_3',
      'spacing_2', 'spacing_3',
      'schema_2', 'schema_3',
      'no-images'
    );
    document.documentElement.style.removeProperty('--font-family');
  
    // Закрываем окно (если управляется через проп `onClose`)
    if (onClose) onClose();
  };



  useEffect(() => {
    if (font !== '1') {
      if (font !== cookies.get('specialSettingsFont', options)) {
        cookies.set('specialSettingsFont', font, options)
        changeClass('font', font)
      }
    } else {
      cookies.remove('specialSettingsFont', options)
      document.documentElement.classList.remove('font_2', 'font_3')
    }
  }, [font])

  useEffect(() => {
    if (spacing !== '1') {
      if (spacing !== cookies.get('specialSettingsSpacing', options)) {
        cookies.set('specialSettingsSpacing', spacing, options)
        changeClass('spacing', spacing)
      }
    } else {
      cookies.remove('specialSettingsSpacing', options)
      document.documentElement.classList.remove('spacing_2', 'spacing_3')
    }
  }, [spacing])

  useEffect(() => {
    if (schema !== '1') {
      if (schema !== cookies.get('specialSettingsSchema', options)) {
        cookies.set('specialSettingsSchema', schema, options)
        changeClass('schema', schema)
      }
    } else {
      cookies.remove('specialSettingsSchema', options)
      document.documentElement.classList.remove('schema_2', 'schema_3')
    }
  }, [schema])



  useEffect(() => {
    if (fontFamily !== cookies.get('specialSettingsFontFamily', options)) {
      cookies.set('specialSettingsFontFamily', fontFamily, options);
      document.documentElement.style.setProperty('--font-family', fontFamily);
    }
  }, [fontFamily]);
  
  useEffect(() => {
    const value = imagesEnabled ? 'true' : 'false';
    cookies.set('specialSettingsImagesEnabled', value, options);
    
    if (imagesEnabled) {
      document.documentElement.classList.remove('no-images');
    } else {
      document.documentElement.classList.add('no-images');
    }
  }, [imagesEnabled]);

  return (
    <div className={classNames(styles.root, { [styles.active]: active })}>
      <div className={styles.groups}>
        <div className={styles.group}>
          <div className={styles.label}>
            Шрифт
          </div>

          <div className={styles.items}>
            <div
              className={classNames(
                styles.item, styles.font, styles.normal, {
                  [styles.active]: font === '1'
                }
              )}
              onClick={() => setFont('1')}
            />

            <div
              className={classNames(
                styles.item, styles.font, styles.big, {
                  [styles.active]: font === '2'
                }
              )}
              onClick={() => setFont('2')}
            />

            <div
              className={classNames(
                styles.item, styles.font, styles.bigger, {
                  [styles.active]: font === '3'
                }
              )}
              onClick={() => setFont('3')}
            />
          </div>
        </div>

        <div className={styles.group}>
          <div className={styles.label}>
            Интервал
          </div>

          <div className={styles.items}>
            <div
              className={classNames(
                styles.item, styles.spacing, styles.normal, {
                  [styles.active]: spacing === '1'
                }
              )}
              onClick={() => setSpacing('1')}
            />

            <div
              className={classNames(
                styles.item, styles.spacing, styles.big, {
                  [styles.active]: spacing === '2'
                }
              )}
              onClick={() => setSpacing('2')}
            />

            <div
              className={classNames(
                styles.item, styles.spacing, styles.bigger, {
                  [styles.active]: spacing === '3'
                }
              )}
              onClick={() => setSpacing('3')}
            />

          </div>
        </div>

        <div className={styles.group}>
          <div className={styles.label}>
            Цветовая схема
          </div>

          <div className={styles.items}>
            <div
              className={classNames(
                styles.item, styles.schema, styles.white, {
                  [styles.active]: schema === '1'
                }
              )}
              onClick={() => setSchema('1')}
            />

            <div
              className={classNames(
                styles.item, styles.schema, styles.black, {
                  [styles.active]: schema === '2'
                }
              )}
              onClick={() => setSchema('2')}
            />

            <div
              className={classNames(
                styles.item, styles.schema, styles.blue, {
                  [styles.active]: schema === '3'
                }
              )}
              onClick={() => setSchema('3')}
            />
          </div>
        </div>



        <div className={styles.group}>
          <div className={styles.label}>
            Тип шрифта
          </div>
          <div className={styles.items}>
            <div
              className={classNames(styles.item, styles.fontFamily, { [styles.active]: fontFamily === 'sans-serif' })}
              onClick={() => setFontFamily('sans-serif')}
              title="Sans-serif"
            >Ss</div>
            <div
              className={classNames(styles.item, styles.fontFamily, { [styles.active]: fontFamily === 'serif' })}
              onClick={() => setFontFamily('serif')}
              title="Serif"
            >S</div>
            <div
              className={classNames(styles.item, styles.fontFamily, { [styles.active]: fontFamily === 'monospace' })}
              onClick={() => setFontFamily('monospace')}
              title="Monospace"
            >Ms</div>
          </div>
        </div>

        <div className={styles.group}>
          <div className={styles.label}>
            Изображения
          </div>
          <div className={styles.items}>
            <div
              className={classNames(styles.item, styles.toggle, { [styles.active]: imagesEnabled })}
              onClick={() => setImagesEnabled(!imagesEnabled)}
            >
              {imagesEnabled ? 'ON' : 'OFF'}
            </div>
          </div>
        </div>

        <div className={styles.group}>
          <button 
            className={styles.resetButton}
            onClick={resetSettings}
          >
            Сбросить настройки
          </button>
        </div>






      </div>
    </div>
  )
}
